class Product {
	id: string = ""
	name: string = ""
	description: string = ""
	colors: string[] = ["gray", "red"]
}

class CartItem {
	color: string = ""
	qty: number = 0
	product?: Product
}

class Cart {
	subscribers: Function[] = []

	items: CartItem[] = []

	add(product: Product, qty: number, color: string){
		// check if item exist, if it does add one qty
		for (var i = 0; i < this.items.length; i++){
			if (this.items[i].product?.id == product?.id){
				this.items[i].qty++;
				this.emit();
				return;
			}
		}
		
		let item = new CartItem()
		item.product = product;
		item.qty = qty;
		item.color = color;
		this.items.push(item)

		this.emit();
	}
	emit(){
		this.subscribers.forEach((sub)=>{
			sub(this);
		})
	}

	removeItem(item: CartItem){
		for (var i = 0; i < this.items.length; i++){
			if (this.items[i].product?.id == item.product?.id){
				this.items.splice(i, 1);
			}
		}
		// check for items and remove them and send update
		this.emit();
	}
	decrementQty(item: CartItem){

	}

	on(sub: string, callback: Function){
		this.subscribers.push(callback)
	}
}
	// items: [{}, {}]
export let cart = new Cart();